import React, { createContext, useReducer, useCallback } from 'react';
import postReducer from './reducers/postReducer';
import {
    getAllPosts,
    getPublishedPosts,
    getPostsByCategory,
    getPostById,
    createPost,
    updatePost,
    deletePost,
    uploadImage
} from '../utils/api.js';
import {
    GET_POSTS,
    GET_POST,
    ADD_POST,
    UPDATE_POST,
    DELETE_POST,
    POST_ERROR,
    POST_LOADING,
} from './types.js';

export const PostContext = createContext();

export const PostProvider = ({ children }) => {
    const initialState = {
        posts: [],
        post: null,
        loading: true,
        error: null
    };

    const [state, dispatch] = useReducer(postReducer, initialState);

    // --- עטיפת כל הפונקציות ב-useCallback כדי למנוע רינדורים מיותרים ---

    const getPosts = useCallback(async (lang = 'he') => {
        dispatch({ type: POST_LOADING });
        try {
            const res = await getAllPosts(lang);
            dispatch({ type: GET_POSTS, payload: res.data });
        } catch (err) {
            dispatch({ type: POST_ERROR, payload: err.response?.data?.msg });
        }
    }, []); // מערך תלויות ריק מבטיח שהפונקציה נוצרת רק פעם אחת

    const getPublished = useCallback(async (lang = 'he') => {
        dispatch({ type: POST_LOADING });
        try {
            const res = await getPublishedPosts(lang);
            dispatch({ type: GET_POSTS, payload: res.data });
        } catch (err) {
            dispatch({ type: POST_ERROR, payload: err.response?.data?.msg });
        }
    }, []);

    const getByCategory = useCallback(async (category, lang = 'he') => {
        dispatch({ type: POST_LOADING });
        try {
            const res = await getPostsByCategory(category, lang);
            dispatch({ type: GET_POSTS, payload: res.data });
        } catch (err) {
            dispatch({ type: POST_ERROR, payload: err.response?.data?.msg || "Error loading posts" });
        }
    }, []);

    const getPost = useCallback(async (id) => {
        dispatch({ type: POST_LOADING });
        try {
            const res = await getPostById(id);
            dispatch({ type: GET_POST, payload: res.data });
        } catch (err) {
            dispatch({ type: POST_ERROR, payload: err.response.data.msg });
        }
    }, []);

    const addPost = useCallback(async (formData) => {
        try {
            const res = await createPost(formData);
            dispatch({ type: ADD_POST, payload: res.data });
        } catch (err) {
            dispatch({ type: POST_ERROR, payload: err.response.data.msg });
        }
    }, []);

    const editPost = useCallback(async (id, formData) => {
        try {
            const res = await updatePost(id, formData);
            dispatch({ type: UPDATE_POST, payload: res.data });
        } catch (err) {
            dispatch({ type: POST_ERROR, payload: err.response.data.msg });
        }
    }, []);

    const removePost = useCallback(async (id) => {
        try {
            await deletePost(id);
            dispatch({ type: DELETE_POST, payload: id });
        } catch (err) {
            dispatch({ type: POST_ERROR, payload: err.response.data.msg });
        }
    }, []);

    const upload = useCallback(async (formData) => {
        try {
            const res = await uploadImage(formData);
            return res.data.imageUrl;
        } catch (err) {
            dispatch({ type: POST_ERROR, payload: err.response.data.msg });
            return null;
        }
    }, []);

    return (
        <PostContext.Provider
            value={{
                posts: state.posts,
                post: state.post,
                loading: state.loading,
                error: state.error,
                getPosts,
                getPublished,
                getByCategory,
                getPost,
                addPost,
                editPost,
                removePost,
                upload
            }}
        >
            {children}
        </PostContext.Provider>
    );
};